var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPayServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 237,
    viewBox: "0 0 238 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.74219,
    y: 12.3262,
    width: 142.031,
    height: 182.046,
    rx: 3.5,
    fill: "#F3F3F3",
    stroke: "#EDEDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9746,
    y: 121.647,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9746,
    y: 102.126,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9746,
    y: 141.174,
    width: 109.825,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9746,
    y: 160.708,
    width: 78.0978,
    height: 7.32167,
    rx: 3.66083,
    fill: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9 48.2988L76.7854 39.1699L55.3423 48.2988V58.8843C55.3423 65.0026 54.8157 71.4122 62.1614 81.1237C66.0396 86.2511 73.5265 89.3462 76.7854 90.2526C79.2502 89.9289 85.5599 87.6499 91.0809 81.1237C97.9 73.0632 97.9273 63.5782 97.9 58.8843V48.2988Z",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1045 66.1446L73.7803 72.7665L86.078 57.6309",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.92 119.295L191.577 84.0169C196.092 77.5558 195.233 68.769 189.551 63.3054C187.806 61.6276 185.044 61.6382 183.312 63.3292L140.049 105.57C128.817 116.537 120.578 130.196 116.115 145.247L103.892 186.479C98.1763 205.757 112.672 225.09 132.779 225.006L195.54 224.745C201.244 224.722 206.671 222.281 210.475 218.03C214.15 213.922 215.112 208.055 212.94 202.989L212 200.795C218.859 200.199 224.555 195.257 226.115 188.552L226.519 186.814C227.7 181.736 225.47 176.477 221 173.795L222.404 173.374C227.517 171.84 231.04 167.159 231.098 161.821L231.141 157.97C231.208 151.792 226.841 146.452 220.771 145.295C226.658 145.295 231.523 140.703 231.862 134.826L232.11 130.523C232.462 124.429 227.615 119.295 221.511 119.295H166.92Z",
    fill: "#FFDCD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayServiceBody2);
export default __webpack_public_path__ + "static/media/IcPayServiceBody2.7af8e5875d13ee84a3b158d752abb544.svg";
export { ForwardRef as ReactComponent };